import { useEffect, useState } from "react";
import { getUsersBelowTarget } from "../actions";
import { formatParamsGet, resolveErrorMessage } from "../util";

const useFetchUsersBelowTargets = (agents, hierarchyViewType) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setUsers([]);
        setError(null);
        if (!agents?.length) return;

        setLoading(true);

        const agentIds = agents.map((a) => a.id);
        const submitParams = {
          agentIds,
          hierarchyViewType,
        };

        const params = formatParamsGet(submitParams);
        const response = await getUsersBelowTarget(params);
        if (!response?.length) throw new Error("app.users.byAgent.notFound");

        setUsers(response);
      } catch (e) {
        setError(resolveErrorMessage(e));
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [agents, hierarchyViewType]);

  return {
    users,
    loading,
    error,
  };
};

export default useFetchUsersBelowTargets;
